customElements.define('product-form', class ProductForm extends HTMLElement {
  constructor() {
    super()
    
    this.formElement = this.querySelector('form');
    this.formElement.addEventListener('submit', this.onSubmitHandler.bind(this));

  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-outer',
        section: 'cart-items',
        selector: '.cart__cart-items'
      },
      {
        id: 'cart-outer',
        section: 'cart-summary',
        selector: '.cart__summary-outer'
      },
      {
        id: 'cart-drawer',
        section: 'cart-items',
        selector: '.cart__cart-items'
      },
      {
        id: 'cart-drawer',
        section: 'cart-footer',
        selector: '.cart-drawer__footer'
      },
      {
        id: 'nav-inner',
        section: 'cart-nav-icon',
        selector: '.nav__link--cart'
      }
    ];
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    console.log('SUBMIT CLICKED')
    
    fetch("/cart/add.json", {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
      },
      body: JSON.stringify({
          id: this.querySelector('#productFormSelector').value,
          quantity: this.querySelector('#main-product__quantity-input').value,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
      })
    }).then(response => {
      if(response.ok) {
        return response.json();
      }
      throw new Error('Request Failed!');
    }, networkError => console.log(networkError.message)
    ).then((response) => {
      console.log('Product(s) Added')
      this.getSectionsToRender().forEach((section => {
        if (document.getElementById(section.id) != null && document.getElementById(section.id).querySelector(section.selector) != null || document.getElementById(section.id) != null) {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(response.sections[section.section], section.selector);
          cartDrawerOpen();
        }
      }))
    })
   .catch((e) => {
      console.error(e);
    })
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
})
